// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"636cacb2","453":"4de913d9","667":"e5b45cd2","977":"098482c6"}[chunkId] + ".chunk.js";
};